import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './auth.scss';
import AppIcons from '../../assets/images/icons';
import RegisterForm from './forms/register.form';
import RegisterDetailsForm from './forms/register-details.form';

const RegisterPage = () => {
    const isLogin = useRef(null);
    const [step, setStep] = useState(0);
    const [prefill, setPrefill] = useState({});

    useEffect(() => {
        const isLoginPage = isLogin.current;
        if (isLoginPage && isLoginPage.classList.contains('login-class-adder')) {
            document.body.classList.add('login-page');
        } else {
            document.body.classList.remove('login-page');
        }
        return () => {
            document.body.classList.remove('login-page');
        };
    }, []);

    const handleStep1Success = (userData) => {
        setPrefill(userData);
        setStep(1);
    };

    return (
        <>
            <div ref={isLogin} className={`login-class-adder login-wrpx register-wrp auth-layout`}>
                <div className='auth-page-layout f-wrp'>
                    <div className={`flex-box`}>
                        <div className='form-sec-wrp' style={{ position: 'relative' }}>
                            <div className='auth-form'>
                                <Link to={'/'} className='auth-logo'>
                                    <img src={AppIcons.logo} alt='Pnp ai Logo' />
                                </Link>
                                <br /> <br />
                                <div style={{ overflow: 'hidden' }}>
                                    <div style={{
                                        display: 'flex',
                                        width: '200%',
                                        transform: step === 0 ? 'translateX(0)' : 'translateX(-50%)',
                                        transition: 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
                                    }}>
                                        <div style={{ width: '50%', minWidth: '50%' }}>
                                            <RegisterForm onSuccess={handleStep1Success} />
                                        </div>
                                        <div style={{ width: '50%', minWidth: '50%' }}>
                                            <RegisterDetailsForm prefill={prefill} onBack={() => setStep(0)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='form-img-wrp'>
                    <span>
                        <img src={AppIcons.loginBG1} alt='PnP login' />
                    </span>
                </div>
            </div>
        </>
    );
};

export default RegisterPage;
